import { mapState } from "vuex";

export const windowResized = {
  created() {
    window.addEventListener("resize", this.windowResized);
    // console.log('created');

    // if(!this.windowResizeEventFired){ //aint working
    // window.addEventListener("resize", this.windowResized);
    //     this.$store.commit('SET_WSR');
    // }
  },
  data() {
    return {
      minWidth: 992,
      isMobile: false,
    };
  },
  mounted() {
    // console.log('mounted');
    this.windowResized();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowResized);
  },
  computed: {
    ...mapState(["windowResizeEventFired"]),
  },
  methods: {
    windowResized() {
      let wSize = window.innerWidth;
      if (wSize > this.minWidth) {
        this.isMobile = false;
        (this.openLinks = true),
          (this.isNavActive = true),
          (this.showCarLook = true);
        this.showCarOptions = true;
      } else {
        this.isMobile = true;
        (this.openLinks = false),
          (this.isNavActive = false),
          (this.showCarLook = true);
        this.showCarOptions = false;
      }

      // console.log([this.isMobile , this.openLinks, this.isNavActive,  this.showCarLook ,  this.showCarOptions]);
      document.body.classList.remove("isActive");
      // console.log('runing and runing', wSize);
      // console.log('-----------', this.isNavActive);
    },
  },
};

export const handleNavOnScroll = {
  created() {
    window.addEventListener("scroll", this.changeNav);
  },
  data() {
    return {
      runTrigger: true,
    };
  },
  mounted() {
    this.changeNav();
  },
  watch: {
    isMobile: function () {
      this.unsetProperties("relative", "unset", "flex", true);
    },
  },
  methods: {
    changeNav() {
      // needs this.isMobile from -> windowResized - vue mixin
      let pageY = window.pageYOffset;
      let stTrigger = 0;
      let ndTriger = 103;

      // console.log('nav changes');

      if (this.isMobile && this.$route.path != "/") {
        if (pageY == stTrigger) {
          this.unsetProperties("relative", "unset", "flex", true);
        } else if (pageY > ndTriger && this.runTrigger) {
          this.unsetProperties("fixed", "153px", "none", false);
        }
      }
    },
    unsetProperties(pos, margin, nav, trig) {
      let appCont = document.querySelector(".appContent");
      let navCont = document.querySelector(".nav");
      let navTop = document.querySelector(".navbar");

      if (navCont) navCont.style.position = pos;
      if (appCont) appCont.style.marginTop = margin;
      if (navTop) navTop.style.display = nav;
      this.runTrigger = trig;
    },
  },
};
